// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__cctDA","addWidgetButton":"Header_addWidgetButton__O6a4e","dashboardTabs":"Header_dashboardTabs__2IT7q","active":"Header_active__pRahX"};